import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
import './css/index.css';

ReactDOM.render(
  <App />,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js